var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"py-5 mx-auto",class:{'w-full': _vm.fullWidth, 'w-2/3': !_vm.fullWidth},attrs:{"action":_vm.action}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }